(function () {
  if (window.__lmpCartFeedbackReady) return;
  window.__lmpCartFeedbackReady = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getCart() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart load failed');
      return response.json();
    });
  }

  function money(cents) {
    var value = Number(cents || 0);
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(value / 100);
    } catch (e) {
      return (value / 100).toFixed(2).replace('.', ',') + ' EUR';
    }
  }

  function ensureHeaderCartChips() {
    document.querySelectorAll('[data-lmp-cart-icon]').forEach(function (icon) {
      if (!icon.querySelector('[data-lmp-cart-total-chip]')) {
        var chip = document.createElement('span');
        chip.className = 'lmp-cart-total-chip';
        chip.setAttribute('data-lmp-cart-total-chip', '');
        chip.hidden = true;
        icon.appendChild(chip);
      }
    });
  }

  function applyV57Hotfix() {
    if (!document.getElementById('lmp-v57-hotfix-style')) {
      var style = document.createElement('style');
      style.id = 'lmp-v57-hotfix-style';
      style.textContent = [
        'body,body.gradient{margin:0!important;}',
        '#MainContent,.content-for-layout{margin-bottom:0!important;padding-bottom:0!important;}',
        '.shopify-section:has(.lmp-footer){margin-top:0!important;padding-top:0!important;padding-bottom:0!important;background:#18130f!important;}',
        '.lmp-footer,.lmp-footer-v36,.lmp-footer-v57{display:block!important;visibility:visible!important;opacity:1!important;margin-top:0!important;margin-bottom:0!important;border-top:0!important;}',
        '.lmp-footer + *{margin-top:0!important;}',
        '.shopify-section-group-footer-group{margin-top:0!important;padding-top:0!important;background:#18130f!important;}',
        '.shopify-section-group-footer-group .section-background,.shopify-section-group-footer-group .section{background:#18130f!important;margin:0!important;padding-top:0!important;}',
        '.lmp-global-logo-img,.lmp-global-logo img,.lmp-logo img{filter:brightness(0) invert(1) drop-shadow(0 10px 18px rgba(0,0,0,.34))!important;}',
        '.lmp-global-logo span,.lmp-logo span{color:#fff8ee!important;}',
        '.lmp-cart-total-chip{position:absolute;left:50%;bottom:-18px;transform:translateX(-50%);min-width:max-content;padding:5px 9px;border-radius:999px;background:linear-gradient(135deg,rgba(255,248,236,.98),rgba(244,201,120,.96));color:#241507;border:1px solid rgba(255,255,255,.82);box-shadow:0 12px 28px rgba(24,18,12,.20);font-size:11px;line-height:1;font-weight:950;letter-spacing:-.01em;pointer-events:none;white-space:nowrap;z-index:7;}',
        '.lmp-cart-total-chip[hidden]{display:none!important;}',
        '.shopify-policy__container{max-width:1280px!important;width:min(1280px,calc(100% - 48px))!important;margin:clamp(110px,10vw,150px) auto clamp(60px,8vw,100px)!important;padding:clamp(28px,5vw,64px)!important;border-radius:32px!important;background:linear-gradient(135deg,rgba(255,255,255,.92),rgba(255,248,236,.76))!important;box-shadow:0 28px 90px rgba(45,33,20,.14)!important;}',
        '.shopify-policy__title h1{font-size:clamp(36px,5vw,72px)!important;line-height:1.02!important;letter-spacing:-.04em!important;text-align:left!important;margin-bottom:28px!important;}',
        '.shopify-policy__body{font-size:clamp(16px,1.2vw,19px)!important;line-height:1.75!important;color:#302820!important;}',
        '.lmp-standard-page{max-width:1280px!important;width:100%!important;}',
        '.lmp-standard-page .lmp-richtext{max-width:1120px!important;font-size:clamp(16px,1.2vw,19px)!important;line-height:1.75!important;}',
        '@media(max-width:760px){.lmp-cart-total-chip{display:none!important}.shopify-policy__container{width:min(100% - 28px,1280px)!important;margin-top:96px!important;padding:24px!important;border-radius:24px!important;}}'
      ].join('\n');
      document.head.appendChild(style);
    }
    var linkMap = {
      '/collections/wohnen-moebel': '/collections/mobel',
      '/collections/spiegeltherapie': '/collections/therapiespiegel-zur-spiegeltherapie',
      '/collections/gamingstuehle': '/collections/gaming-sessel',
      '/collections/werbe-und-messebedarf': '/collections/werbe-messebedarf',
      '/collections/personalisierte-produkte': '/search?q=gravur',
      '/collections/3d-druck': '/search?q=3d-druck',
      '/collections/angebote': '/collections/all?sort_by=created-descending',
      '/collections/geschenkideen': '/search?q=geschenk',
      '/pages/kontakt': '/pages/contact',
      '/pages/versand-zahlung': '/policies/shipping-policy',
      '/pages/datenschutz': '/policies/privacy-policy',
      '/pages/impressum': '/policies/legal-notice'
    };
    document.querySelectorAll('a[href]').forEach(function (a) {
      var raw = a.getAttribute('href');
      if (linkMap[raw]) a.setAttribute('href', linkMap[raw]);
    });
    ensureHeaderCartChips();
  }

  function setCart(cart) {
    var count = Number(cart && cart.item_count || 0);
    var total = Number(cart && cart.total_price || 0);
    document.querySelectorAll('[data-lmp-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.setAttribute('data-count', String(count));
      badge.hidden = count <= 0;
    });
    document.querySelectorAll('[data-lmp-cart-total-chip]').forEach(function (chip) {
      chip.textContent = money(total);
      chip.hidden = count <= 0;
    });
    document.querySelectorAll('[data-lmp-cart-count-label]').forEach(function (label) {
      label.textContent = count === 1 ? '1 Artikel im Warenkorb' : count + ' Artikel im Warenkorb';
    });
    document.querySelectorAll('[data-lmp-cart-icon]').forEach(function (icon) {
      icon.classList.toggle('has-items', count > 0);
      icon.classList.add('is-bumping');
      window.setTimeout(function () { icon.classList.remove('is-bumping'); }, 620);
    });
  }

  function showToast(detail) {
    var toast = document.querySelector('[data-lmp-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lmp-cart-toast';
      toast.setAttribute('data-lmp-cart-toast', '');
      toast.innerHTML = '<strong>Im Warenkorb</strong><span data-lmp-cart-toast-text>Der Artikel wurde hinzugefügt.</span><a href="/cart">Warenkorb ansehen</a>';
      document.body.appendChild(toast);
    }
    var text = toast.querySelector('[data-lmp-cart-toast-text]');
    if (text) text.textContent = detail && detail.title ? detail.title + ' wurde hinzugefügt.' : 'Der Artikel wurde hinzugefügt.';
    toast.classList.add('is-visible');
    clearTimeout(toast.__lmpTimer);
    toast.__lmpTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2800);
  }

  function refresh(detail) {
    getCart().then(function (cart) {
      setCart(cart);
      if (detail && detail.showToast !== false) showToast(detail);
    }).catch(function () {
      if (detail && detail.showToast !== false) showToast(detail);
    });
  }

  ready(function () {
    applyV57Hotfix();
    ensureHeaderCartChips();
    getCart().then(function (cart) { setCart(cart); }).catch(function () {});
  });

  document.addEventListener('lmp:cart:add', function (event) { refresh(event.detail || {}); });
  document.addEventListener('lmp:cart:update', function (event) { refresh(event.detail || { showToast: false }); });
})();